import { computed, makeObservable } from 'mobx';

import { CallProviderType } from '@gem/call/Model/callModel.types';
import dateService from '@gem/services/date-service';

import Entities from 'STORE';
import { Group } from 'STORE/Groups/Group';

interface IBackgroundCallConstructorParams {
  groupId: string;
  channelId: string;
  callProvider: CallProviderType;
}

export class BackgroundCall {
  groupId: string;
  channelId: string;
  startTs: number;
  callProvider: CallProviderType;

  constructor({ groupId, channelId, callProvider }: IBackgroundCallConstructorParams) {
    makeObservable(this);
    this.groupId = groupId;
    this.channelId = channelId;
    this.startTs = dateService.now().valueOf();
    this.callProvider = callProvider;
  }

  @computed
  get group(): Group | null {
    return Entities.GroupsStore.getGroupById(this.groupId);
  }

  @computed
  get isGroup(): boolean {
    return !!this.group?.isChatGroup;
  }
}
